@import "tailwindcss";

html,
body,
#root {
  min-height: 100%;
  margin: 0;
}

body {
  background: #f3f4f6;
  font-family: 'Segoe UI', 'Hiragino Sans', 'Meiryo', sans-serif;
  font-size: 14px;
}

input[type='checkbox'] {
  width: 1rem;
  height: 1rem;
  min-width: 1rem;
  min-height: 1rem;
  flex-shrink: 0;
  accent-color: #2563eb;
  cursor: pointer;
}

input[type='checkbox']:disabled {
  cursor: not-allowed;
}

label:has(input[type='checkbox']) {
  line-height: 1.55;
}

@media print {
  .no-print {
    display: none !important;
  }

  .print-break {
    break-inside: avoid;
  }
}

.customer-inline-error {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: 4px;
  color: #ff4d4f;
  font-size: 10px;
  line-height: 1.25;
}
.customer-inline-error::before {
  content: "●";
  font-size: 9px;
  font-weight: 900;
  line-height: 1.25;
  margin-top: 1px;
}

@keyframes toastSlideUp {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}
